import React from "react"
import PropTypes from "prop-types"
import PageLayout from "../styleguide-components/layout"

const Layout = ({ children }) => {
  return <PageLayout>{children}</PageLayout>
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
